// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compact-navbar {
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  border-bottom: 1px solid #e5e7eb;
}

/* Vertical Separators */
.menu-separator {
  width: 1px;
  height: 24px;
  background: #e5e7eb;
  margin: 0 8px;
}

.dark .menu-separator {
  background: #374151;
}

.mobile-separator {
  height: 1px;
  background: #e5e7eb;
  margin: 8px 24px;
}

.dark .mobile-separator {
  background: #374151;
}

.dark.compact-navbar {
  background: #1f2937;
  color: #f9fafb;
  border-bottom: 1px solid #374151;
}

/* Left Section */
.nav-left {
  display: flex;
  align-items: center;
  gap: 32px;
}

.logo {
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.desktop-menu {
  display: flex;
  gap: 4px;
}

/* Remove text decoration from all links in the navbar */
.compact-navbar a {
  text-decoration: none;
}

/* Menu link styles */
.menu-link {
  color: inherit; /* Inherit color from parent */
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
}

/* Dropdown item styles */
.dropdown-item,
.mobile-dropdown-item {
  color: inherit;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
}

/* Dark mode link colors */
.compact-navbar.dark a {
  color: #f0f0f0;
}

.compact-navbar:not(.dark) a {
  color: #333;
}

.menu-item {
  position: relative;
  cursor: pointer;
}

.menu-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #374151;
}

.dark .menu-link {
  color: #e5e7eb;
}

.menu-link:hover {
  background: #f3f4f6;
  color: #2563eb;
}

.dark .menu-link:hover {
  background: #374151;
  color: #60a5fa;
}

.arrow {
  transition: transform 0.2s;
}

.arrow.rotate {
  transform: rotate(180deg);
}

/* Dropdown Menu */
.dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  z-index: 1001;
  border: 1px solid #e5e7eb;
  padding: 4px;
}

.dark .dropdown-menu {
  background: #1f2937;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border-color: #374151;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  font-size: 14px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  color: #374151;
}

.dark .dropdown-item {
  color: #e5e7eb;
}

.dropdown-item:hover {
  background: #f3f4f6;
  color: #2563eb;
}

.dark .dropdown-item:hover {
  background: #374151;
  color: #60a5fa;
}

/* Right Section */
.nav-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.theme-btn {
  padding: 8px;
  cursor: pointer;
  border: none;
  background: none;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.theme-btn:hover {
  background: #f3f4f6;
}

.dark .theme-btn:hover {
  background: #374151;
}

.notifications {
  padding: 8px;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.notifications:hover {
  background: #f3f4f6;
}

.dark .notifications:hover {
  background: #374151;
}

.badge {
  position: absolute;
  top: 2px;
  right: 2px;
  background: #ef4444;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  border: 2px solid white;
}

.dark .badge {
  border-color: #1f2937;
}

.user-avatar img {
  border-radius: 50%;
  object-fit: cover;
}

/* Mobile Menu */
.mobile-btn {
  display: none;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
  color: inherit;
}

.mobile-btn:hover {
  background: #f3f4f6;
}

.dark .mobile-btn:hover {
  background: #374151;
}

.mobile-menu {
  display: none;
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  background: white;
  padding: 12px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 999;
  border-top: 1px solid #e5e7eb;
}

.dark .mobile-menu {
  background: #1f2937;
  border-top-color: #374151;
}

.mobile-menu-item {
  padding: 0 20px;
}

.mobile-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
}

.dark .mobile-link {
  color: #e5e7eb;
}

.mobile-dropdown {
  padding-left: 20px;
  margin-top: 8px;
}

.mobile-dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  font-size: 14px;
  color: #6b7280;
  cursor: pointer;
}

.dark .mobile-dropdown-item {
  color: #9ca3af;
}

/* Remove text decoration from all links in the navbar */
.compact-navbar a {
  text-decoration: none;
}

/* Menu link styles */
.menu-link {
  color: inherit; /* Inherit color from parent */
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
}

/* Dropdown item styles */
.dropdown-item,
.mobile-dropdown-item {
  color: inherit;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
}

/* Dark mode link colors */
.compact-navbar.dark a {
  color: #f0f0f0;
}

.compact-navbar:not(.dark) a {
  color: #333;
}

/* Footer styles */
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  background-color: #f8f9fa;
  padding: 8px 0;
  text-align: center;
  border-top: 1px solid #e9ecef;
}

.footer.dark {
  background-color: #2c3e50;
  border-top: 1px solid #34495e;
  color: #ecf0f1;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.footer-links a {
  margin-left: 15px;
  text-decoration: none;
  color: inherit;
}

.footer-links a:hover {
  text-decoration: underline;
}

/* Dark mode link colors */
.footer.dark a {
  color: #ecf0f1;
}

.footer:not(.dark) a {
  color: #495057;
}

/* User dropdown styles */
.user-menu-container {
  position: relative;
  display: inline-block;
}

.user-avatar {
  cursor: pointer;
  border-radius: 50%;
  overflow: hidden;
  transition: all 0.2s ease;
  border: 2px solid #e5e7eb;
}

.dark .user-avatar {
  border-color: #374151;
}

.user-avatar:hover {
  transform: scale(1.05);
  border-color: #2563eb;
}

.dark .user-avatar:hover {
  border-color: #60a5fa;
}

.user-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 180px;
  z-index: 1000;
  border: 1px solid #e5e7eb;
  padding: 4px;
}

.user-dropdown.dark {
  background-color: #1f2937;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border-color: #374151;
}

.user-dropdown .dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  text-decoration: none;
  color: #374151;
  cursor: pointer;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.user-dropdown.dark .dropdown-item {
  color: #e5e7eb;
}

.user-dropdown .dropdown-item:hover {
  background-color: #f3f4f6;
  color: #2563eb;
}

.user-dropdown.dark .dropdown-item:hover {
  background-color: #374151;
  color: #60a5fa;
}

/* Close dropdown when clicking outside */
body.click-outside-handler {
  position: relative;
}

body.click-outside-handler::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: none;
}

body.click-outside-handler.active::before {
  display: block;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 10px;
  }

  .footer-links a {
    margin: 0 10px;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .mobile-btn {
    display: block;
  }

  .mobile-menu {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Navbar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,wDAAwD;AACxD;EACE,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,cAAc,EAAE,8BAA8B;EAC9C,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;;EAEE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,yCAAyC;EACzC,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,cAAc,EAAE,8BAA8B;EAC9C,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;;EAEE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".compact-navbar {\n  height: 64px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 24px;\n  background: white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n/* Vertical Separators */\n.menu-separator {\n  width: 1px;\n  height: 24px;\n  background: #e5e7eb;\n  margin: 0 8px;\n}\n\n.dark .menu-separator {\n  background: #374151;\n}\n\n.mobile-separator {\n  height: 1px;\n  background: #e5e7eb;\n  margin: 8px 24px;\n}\n\n.dark .mobile-separator {\n  background: #374151;\n}\n\n.dark.compact-navbar {\n  background: #1f2937;\n  color: #f9fafb;\n  border-bottom: 1px solid #374151;\n}\n\n/* Left Section */\n.nav-left {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n}\n\n.logo {\n  font-weight: 600;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n}\n\n.desktop-menu {\n  display: flex;\n  gap: 4px;\n}\n\n/* Remove text decoration from all links in the navbar */\n.compact-navbar a {\n  text-decoration: none;\n}\n\n/* Menu link styles */\n.menu-link {\n  color: inherit; /* Inherit color from parent */\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n}\n\n/* Dropdown item styles */\n.dropdown-item,\n.mobile-dropdown-item {\n  color: inherit;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n}\n\n/* Dark mode link colors */\n.compact-navbar.dark a {\n  color: #f0f0f0;\n}\n\n.compact-navbar:not(.dark) a {\n  color: #333;\n}\n\n.menu-item {\n  position: relative;\n  cursor: pointer;\n}\n\n.menu-link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #374151;\n}\n\n.dark .menu-link {\n  color: #e5e7eb;\n}\n\n.menu-link:hover {\n  background: #f3f4f6;\n  color: #2563eb;\n}\n\n.dark .menu-link:hover {\n  background: #374151;\n  color: #60a5fa;\n}\n\n.arrow {\n  transition: transform 0.2s;\n}\n\n.arrow.rotate {\n  transform: rotate(180deg);\n}\n\n/* Dropdown Menu */\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  min-width: 200px;\n  z-index: 1001;\n  border: 1px solid #e5e7eb;\n  padding: 4px;\n}\n\n.dark .dropdown-menu {\n  background: #1f2937;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  border-color: #374151;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  font-size: 14px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  color: #374151;\n}\n\n.dark .dropdown-item {\n  color: #e5e7eb;\n}\n\n.dropdown-item:hover {\n  background: #f3f4f6;\n  color: #2563eb;\n}\n\n.dark .dropdown-item:hover {\n  background: #374151;\n  color: #60a5fa;\n}\n\n/* Right Section */\n.nav-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.theme-btn {\n  padding: 8px;\n  cursor: pointer;\n  border: none;\n  background: none;\n  color: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.theme-btn:hover {\n  background: #f3f4f6;\n}\n\n.dark .theme-btn:hover {\n  background: #374151;\n}\n\n.notifications {\n  padding: 8px;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.notifications:hover {\n  background: #f3f4f6;\n}\n\n.dark .notifications:hover {\n  background: #374151;\n}\n\n.badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  background: #ef4444;\n  color: white;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n  border: 2px solid white;\n}\n\n.dark .badge {\n  border-color: #1f2937;\n}\n\n.user-avatar img {\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n/* Mobile Menu */\n.mobile-btn {\n  display: none;\n  background: none;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  color: inherit;\n}\n\n.mobile-btn:hover {\n  background: #f3f4f6;\n}\n\n.dark .mobile-btn:hover {\n  background: #374151;\n}\n\n.mobile-menu {\n  display: none;\n  position: absolute;\n  top: 64px;\n  left: 0;\n  right: 0;\n  background: white;\n  padding: 12px 0;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 999;\n  border-top: 1px solid #e5e7eb;\n}\n\n.dark .mobile-menu {\n  background: #1f2937;\n  border-top-color: #374151;\n}\n\n.mobile-menu-item {\n  padding: 0 20px;\n}\n\n.mobile-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n}\n\n.dark .mobile-link {\n  color: #e5e7eb;\n}\n\n.mobile-dropdown {\n  padding-left: 20px;\n  margin-top: 8px;\n}\n\n.mobile-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 0;\n  font-size: 14px;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n.dark .mobile-dropdown-item {\n  color: #9ca3af;\n}\n\n/* Remove text decoration from all links in the navbar */\n.compact-navbar a {\n  text-decoration: none;\n}\n\n/* Menu link styles */\n.menu-link {\n  color: inherit; /* Inherit color from parent */\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n}\n\n/* Dropdown item styles */\n.dropdown-item,\n.mobile-dropdown-item {\n  color: inherit;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n}\n\n/* Dark mode link colors */\n.compact-navbar.dark a {\n  color: #f0f0f0;\n}\n\n.compact-navbar:not(.dark) a {\n  color: #333;\n}\n\n/* Footer styles */\n.footer {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  left: 0;\n  background-color: #f8f9fa;\n  padding: 8px 0;\n  text-align: center;\n  border-top: 1px solid #e9ecef;\n}\n\n.footer.dark {\n  background-color: #2c3e50;\n  border-top: 1px solid #34495e;\n  color: #ecf0f1;\n}\n\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n}\n\n.footer-links a {\n  margin-left: 15px;\n  text-decoration: none;\n  color: inherit;\n}\n\n.footer-links a:hover {\n  text-decoration: underline;\n}\n\n/* Dark mode link colors */\n.footer.dark a {\n  color: #ecf0f1;\n}\n\n.footer:not(.dark) a {\n  color: #495057;\n}\n\n/* User dropdown styles */\n.user-menu-container {\n  position: relative;\n  display: inline-block;\n}\n\n.user-avatar {\n  cursor: pointer;\n  border-radius: 50%;\n  overflow: hidden;\n  transition: all 0.2s ease;\n  border: 2px solid #e5e7eb;\n}\n\n.dark .user-avatar {\n  border-color: #374151;\n}\n\n.user-avatar:hover {\n  transform: scale(1.05);\n  border-color: #2563eb;\n}\n\n.dark .user-avatar:hover {\n  border-color: #60a5fa;\n}\n\n.user-dropdown {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 8px);\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  min-width: 180px;\n  z-index: 1000;\n  border: 1px solid #e5e7eb;\n  padding: 4px;\n}\n\n.user-dropdown.dark {\n  background-color: #1f2937;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  border-color: #374151;\n}\n\n.user-dropdown .dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  text-decoration: none;\n  color: #374151;\n  cursor: pointer;\n  border: none;\n  background: none;\n  width: 100%;\n  text-align: left;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.user-dropdown.dark .dropdown-item {\n  color: #e5e7eb;\n}\n\n.user-dropdown .dropdown-item:hover {\n  background-color: #f3f4f6;\n  color: #2563eb;\n}\n\n.user-dropdown.dark .dropdown-item:hover {\n  background-color: #374151;\n  color: #60a5fa;\n}\n\n/* Close dropdown when clicking outside */\nbody.click-outside-handler {\n  position: relative;\n}\n\nbody.click-outside-handler::before {\n  content: \"\";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  display: none;\n}\n\nbody.click-outside-handler.active::before {\n  display: block;\n}\n\n@media (max-width: 768px) {\n  .footer-content {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .footer-links a {\n    margin: 0 10px;\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .desktop-menu {\n    display: none;\n  }\n\n  .mobile-btn {\n    display: block;\n  }\n\n  .mobile-menu {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
